import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Link from '../Link'

import { Cell, ResponsiveContainer } from '../ResponsiveGrid'
import CardImage from '../CardImage'

const BlogMenu = () => (
  <ResponsiveContainer className="Atrakeur-Blog" white withMargin withPadding>
    <Cell colSpanDesktop="3" colSpanTablet="4" colSpanMobile="4">
      <Link to="/blog/web">
        <CardImage contentID="index_web" size="small" hoverable/>
      </Link>
    </Cell>
    <Cell colSpanDesktop="3" colSpanTablet="4" colSpanMobile="4">
      <Link to="/blog/diy">
        <CardImage contentID="index_diy" size="small" hoverable/>
      </Link>
    </Cell>
    { false && <Cell colSpanDesktop="2" colSpanTablet="4" colSpanMobile="4">
      <Link to="/blog/flight">
        <CardImage contentID="index_flight" size="small" hoverable/>
      </Link>
    </Cell> }
  </ResponsiveContainer>
)
export default BlogMenu



// WEBPACK FOOTER //
// ./src/components/BlogMenu/index.js